import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeleteFact = ({ factId, caseId }: { factId: string; caseId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
      });

      const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/fact/${factId}`, fetchConfig);

      if (response.status === 403) {
        toast.error('You are not authorised to archive this fact');
        return;
      }

      if (!response.ok) {
        toast.error('Failed to archive fact');
        return;
      }

      toast.success('Fact archived');

      queryClient.invalidateQueries([QueryEntity.CaseFacts, { caseId }]);
      // note this won't invalidate other subsets that contain this fact, which it probably should
      queryClient.invalidateQueries({ queryKey: [QueryEntity.SubsetFacts, { subsetId: caseId }] });
      queryClient.invalidateQueries([QueryEntity.KeyFacts, { caseId }]);
    },
  });
};
